'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var classnames = require('classnames');
var React = require('react');
var styled = require('styled-components');
require('../../../../enums/accordion.js');
require('../../../../enums/alert.js');
require('../../../../enums/avatar.js');
require('../../../../enums/breakpoints.js');
var button$1 = require('../../../../enums/button.js');
require('../../../../enums/code-editor.js');
require('../../../../enums/colors.js');
require('../../../../enums/combobox.js');
require('../../../../enums/date.js');
require('../../../../enums/drag-and-drop.js');
require('../../../../enums/dialog.js');
require('../../../../enums/divider.js');
require('../../../../enums/dropdown.js');
require('../../../../enums/fieldset.js');
require('../../../../enums/font-icon.js');
require('../../../../enums/fonts.js');
require('../../../../enums/headings.js');
require('../../../../enums/input.js');
require('../../../../enums/keys.js');
require('../../../../enums/list.js');
require('../../../../enums/listbox.js');
var loader$1 = require('../../../../enums/loader.js');
require('../../../../enums/margin.js');
require('../../../../enums/option.js');
require('../../../../enums/pill.js');
require('../../../../enums/placements.js');
require('../../../../enums/popout.js');
require('../../../../enums/privacy.js');
require('../../../../enums/radio-group.js');
require('../../../../enums/status.js');
require('../../../../enums/switch.js');
require('../../../../enums/table.js');
require('../../../../enums/tooltip.js');
require('../../../../enums/transitions.js');
require('../../../../enums/widths.js');
require('../../../../styles/styled-components/alert.js');
require('../../../../styles/styled-components/animations.js');
require('../../../../styles/styled-components/box-shadow.js');
var button = require('../../../../styles/styled-components/button.js');
require('../../../../themes/alert.js');
require('../../../../themes/button.js');
require('../../../../themes/checkbox.js');
require('../../../../themes/divider.js');
require('../../../../themes/dropdown.js');
require('../../../../themes/fieldset.js');
require('../../../../themes/input.js');
require('../../../../themes/list.js');
require('../../../../themes/listbox.js');
var loader = require('../../../../themes/loader.js');
require('../../../../themes/option.js');
require('../../../../themes/popout.js');
require('../../../../themes/switch.js');
var themes = require('../../../../themes/themes.js');
require('../../../../themes/tooltip.js');
require('../../../../styles/styled-components/font-face.js');
require('../../../../styles/styled-components/global.js');
require('../../../../styles/styled-components/input.js');
require('../../../../styles/styled-components/list.js');
require('../../../../styles/styled-components/listitem.js');
require('../../../../styles/styled-components/media-queries.js');
require('../../../../styles/styled-components/reset.js');
require('../../../../styles/styled-components/outline.js');
require('../../../../styles/styled-components/popout.js');
require('../../../../styles/styled-components/screen-reader.js');
require('../../../../styles/styled-components/switch.js');
require('../../../../styles/styled-components/tooltip.js');
var fontIcon = require('../../icon/font-icon/font-icon.js');
var circleLoader = require('../../loader/circle-loader/circle-loader.js');
require('../../loader/shimmer-loader/shimmer-loader.js');
var baseLink = require('../base-link/base-link.js');

function _interopDefaultCompat (e) { return e && typeof e === 'object' && 'default' in e ? e : { default: e }; }

var classnames__default = /*#__PURE__*/_interopDefaultCompat(classnames);
var React__default = /*#__PURE__*/_interopDefaultCompat(React);
var styled__default = /*#__PURE__*/_interopDefaultCompat(styled);

function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
const BaseButtonLink = /*#__PURE__*/ React.forwardRef((props, ref)=>{
    const { afterIconRight , children , childrenWrapperProps , className , count , countProps , disabled , endIcon , endIconProps , fullWidth , loaderLabel , loaderProps , loading , look , size , startIcon , startIconProps , ...otherProps } = props;
    const [loaderLook, setLoaderLook] = React.useState(loader.getLoaderLookFromButtonLook(look));
    React.useEffect(()=>{
        setLoaderLook(loader.getLoaderLookFromButtonLook(look));
    }, [
        loading,
        look
    ]); // eslint-disable-line react-hooks/exhaustive-deps
    return /*#__PURE__*/ React__default.default.createElement(baseLink.BaseLink, _extends({}, otherProps, {
        className: classnames__default.default({
            'bf-link__button': true,
            'bf-link__button--disabled': disabled,
            'bf-link__button--full-width': fullWidth,
            [`bf-link__button--${look}`]: look,
            [`bf-link__button--${size}`]: !!size,
            [`${className}`]: className
        }),
        disabled: disabled,
        ref: ref
    }), loaderLabel && loading && /*#__PURE__*/ React__default.default.createElement(circleLoader.CircleLoader, _extends({
        buttonLook: look,
        label: loaderLabel,
        look: loaderLook,
        size: loader$1.LoaderSizes.Small
    }, loaderProps, {
        className: classnames__default.default({
            'bf-link__loader': true,
            [`${loaderProps?.className}`]: !!loaderProps?.className
        })
    })), startIcon && /*#__PURE__*/ React__default.default.createElement(fontIcon.FontIcon, _extends({}, startIconProps, {
        className: classnames__default.default({
            'bf-link__start-icon': true,
            [`${startIconProps?.className}`]: !!startIconProps?.className
        }),
        icon: startIcon
    })), /*#__PURE__*/ React__default.default.createElement("span", _extends({}, childrenWrapperProps, {
        className: classnames__default.default({
            'bf-link__children': true,
            [`${childrenWrapperProps?.className}`]: !!childrenWrapperProps?.className
        })
    }), children), endIcon && /*#__PURE__*/ React__default.default.createElement(fontIcon.FontIcon, _extends({}, endIconProps, {
        className: classnames__default.default({
            'bf-link__end-icon': true,
            [`${endIconProps?.className}`]: !!endIconProps?.className
        }),
        icon: endIcon
    })), count !== undefined && /*#__PURE__*/ React__default.default.createElement("span", _extends({}, countProps, {
        className: classnames__default.default({
            'bf-link__count': true,
            [`${countProps?.className}`]: !!countProps?.className
        })
    }), count), afterIconRight && /*#__PURE__*/ React__default.default.createElement("span", null, afterIconRight));
});
const Link = styled__default.default(BaseButtonLink)`
  ${button.baseButtonStyle}
  ${({ look  })=>button.getButtonTheme({
        look
    })}
  ${({ fullWidth , size  })=>button.getButtonWidth({
        fullWidth,
        size
    })}

  .bf-icon {
    font-size: 14px;
  }

  .bf-link__end-icon {
    margin-inline-start: 10px;
  }

  .bf-link__start-icon {
    margin-inline-end: 10px;
  }

  .bf-link__loader {
    margin-inline-end: 10px;
  }

  .bf-loader__circle {
    width: auto;
  }

  .bf-link__count {
    margin-inline-start: 10px;
  }
`;
const ButtonLink = /*#__PURE__*/ React.forwardRef((props, ref)=>{
    const { fullWidth =false , loading =false , look =button$1.ButtonLooks.Primary , ...otherProps } = props;
    const themeContext = React.useContext(styled.ThemeContext);
    return /*#__PURE__*/ React__default.default.createElement(styled.ThemeProvider, {
        theme: themeContext || themes.lightTheme
    }, /*#__PURE__*/ React__default.default.createElement(Link, _extends({}, otherProps, {
        fullWidth: fullWidth,
        loading: loading,
        look: look,
        ref: ref
    })));
});

exports.BaseButtonLink = BaseButtonLink;
exports.ButtonLink = ButtonLink;
//# sourceMappingURL=button-link.js.map
